import { isJsonObject, type JsonObject } from "../../api/http/jsonDecoding";

const STATES = ["draft", "active", "deprecated", "retired", "withdrawn"] as const;
export type LifecycleState = (typeof STATES)[number];

export interface ItemLifecycle {
  readonly state: LifecycleState;
  readonly reason: string | null;
  readonly replacedBy: string | null;
}

/** A process item's stored lifecycle (process-governance.md PG-6); none is active. A step
 * keeps its fields one level down, in `definition`. */
export function itemLifecycle(definition: JsonObject | null): ItemLifecycle | null {
  if (definition === null) {
    return null;
  }
  const nested = definition["definition"];
  const fields = definition["kind"] === "step" && isJsonObject(nested) ? nested : definition;
  const lifecycle = fields["lifecycle"];
  if (!isJsonObject(lifecycle)) {
    return { state: "active", reason: null, replacedBy: null };
  }
  const state = STATES.find((known) => known === lifecycle["state"]) ?? "active";
  const reason = lifecycle["reason"];
  const replacedBy = lifecycle["replaced_by"];
  return {
    state,
    reason: typeof reason === "string" ? reason : null,
    replacedBy: typeof replacedBy === "string" ? replacedBy : null,
  };
}
